import { Link } from "react-router-dom";
import { Check, X } from "lucide-react";
import { photoUrl } from "@/lib/api";
import { ContactLinks, UnlockButton } from "@/components/UnlockContacts";
import { MessageButton } from "@/components/MessageButton";

const STATUS = {
  pending: ["In attesa", "text-amber-400 border-amber-400/30"],
  accepted: ["Selezionata", "text-emerald-400 border-emerald-400/30"],
  rejected: ["Non selezionata", "text-red-400 border-red-400/30"],
};

export const StatusBadge = ({ status, testid }) => {
  const [l, c] = STATUS[status];
  return <span className={`text-[10px] uppercase tracking-[0.15em] border px-2 py-1 ${c}`} data-testid={testid}>{l}</span>;
};

export const ApplicantRow = ({ a, onDecide, onUnlocked }) => {
  const h = a.hostess || {};
  const p = h.profile || {};
  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-5 p-5 bg-[#121418] border border-white/5 fade-up" data-testid={`applicant-row-${a.id}`}>
      <div className="flex items-center gap-4 flex-1">
        <Link to={`/hostess/${h.id}`} className="w-16 h-20 bg-[#181B20] overflow-hidden shrink-0" data-testid={`applicant-photo-link-${a.id}`}>
          {p.photos?.[0] && <img src={photoUrl(p.photos[0])} alt="" className="w-full h-full object-cover" />}
        </Link>
        <div>
          <Link to={`/hostess/${h.id}`} className="font-serif text-2xl hover:text-[#D4AF37] transition-colors" data-testid={`applicant-profile-link-${a.id}`}>{h.name}</Link>
          <p className="text-xs text-neutral-500 mt-1">{p.city} · {p.height ? `${p.height} cm` : ""} · {(p.languages || []).join(", ")}</p>
          {a.message && <p className="text-sm text-neutral-400 mt-2 italic">“{a.message}”</p>}
          <div className="mt-3">
            {a.unlocked ? (
              <div className="flex flex-wrap items-center gap-4">
                <ContactLinks contacts={h.contacts} testid={`applicant-contacts-${a.id}`} />
                <MessageButton hostessId={h.id} testid={`applicant-message-${a.id}`} className="flex items-center gap-1.5 text-[11px] uppercase tracking-[0.15em] text-[#D4AF37] hover:text-[#E6C24B] transition-colors" />
              </div>
            )
              : <UnlockButton hostess={h} onUnlocked={onUnlocked} testid={`applicant-unlock-${a.id}`} className="flex items-center gap-1.5 text-[11px] uppercase tracking-[0.15em] text-[#D4AF37] hover:text-[#E6C24B] transition-colors" />}
          </div>
        </div>
      </div>
      <div className="flex items-center gap-3">
        <StatusBadge status={a.status} testid={`applicant-status-${a.id}`} />
        {a.status !== "accepted" && <button onClick={() => onDecide(a.id, "accepted")} className="w-9 h-9 border border-emerald-400/30 text-emerald-400 hover:bg-emerald-400/10 flex items-center justify-center transition-colors" data-testid={`applicant-accept-${a.id}`} aria-label="Accetta"><Check className="w-4 h-4" /></button>}
        {a.status !== "rejected" && <button onClick={() => onDecide(a.id, "rejected")} className="w-9 h-9 border border-red-400/30 text-red-400 hover:bg-red-400/10 flex items-center justify-center transition-colors" data-testid={`applicant-reject-${a.id}`} aria-label="Rifiuta"><X className="w-4 h-4" /></button>}
      </div>
    </div>
  );
};
